module.exports = __webpack_public_path__ + "static/media/launch-47.66a66a35.svg";